export const GearRevert = (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.736 12.431V10.9572H15.288C15.1891 10.4319 14.9872 9.94578 14.6989 9.51942L15.7185 8.49776L14.6772 7.45652L13.6556 8.47613C13.2313 8.18774 12.7421 7.98588 12.2178 7.88599V6.43896H10.744V7.88599C10.2198 7.98798 9.73265 8.18774 9.30938 8.47718L8.28462 7.45652L7.24233 8.49776L8.264 9.51942C7.97461 9.94478 7.77169 10.4319 7.67181 10.9572H6.22583V12.431H7.67181C7.77274 12.9542 7.97461 13.4413 8.264 13.8688L7.24233 14.8904L8.28462 15.9327L9.30733 14.911C9.7327 15.2004 10.2198 15.4033 10.7451 15.5032V16.9513H12.2189V15.5043C12.7432 15.4033 13.2313 15.2005 13.6567 14.9121L14.6783 15.9327L15.7206 14.8904L14.701 13.8688C14.9903 13.4424 15.1922 12.9542 15.2911 12.431H16.736ZM11.4804 13.3013C10.5937 13.3013 9.87169 12.5814 9.87169 11.6936C9.87169 10.8058 10.5926 10.087 11.4804 10.087C12.3662 10.087 13.0861 10.8058 13.0861 11.6936C13.0871 12.5814 12.3682 13.3013 11.4804 13.3013Z"
      fill="black"
      fillOpacity="0.85"
    />
    <path
      d="M3.31016 11.6534C3.31121 7.19698 6.92307 3.58407 11.3795 3.58407C12.5443 3.58407 13.6412 3.84877 14.6402 4.29367L13.2436 5.68197L18.9442 5.70154L18.9606 0L17.1078 1.84045C15.425 0.852784 13.4733 0.273964 11.3795 0.273964C5.09498 0.273964 0 5.36895 0 11.6535C0 14.2798 0.898095 16.6908 2.39143 18.6167L4.75403 16.2541C3.84672 14.9471 3.31016 13.3631 3.31016 11.6534Z"
      fill="black"
      fillOpacity="0.85"
    />
    <path
      d="M20.8939 5.57077L18.3387 7.72223C19.1317 9.10127 19.5303 10.7234 19.3851 12.4268C19.0061 16.8678 15.0986 20.1584 10.6577 19.7783C10.0438 19.7258 9.45781 19.5919 8.89546 19.4117L10.256 17.7237L4.58838 18.3313L5.19704 24L6.72232 22.108C7.85007 22.6157 9.0695 22.9669 10.3733 23.0782C16.6352 23.6147 22.1463 18.9719 22.6818 12.7111C22.9074 10.0952 22.2173 7.61619 20.8939 5.57077Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

export const CheckMark = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 12C1.75 9.78227 1.74854 8.0435 1.93066 6.68848C2.11575 5.31182 2.50313 4.21953 3.36133 3.36133C4.21953 2.50313 5.31182 2.11575 6.68848 1.93066C8.0435 1.74854 9.78227 1.75 12 1.75H15C15.4142 1.75 15.75 2.08579 15.75 2.5C15.75 2.91421 15.4142 3.25 15 3.25H12C9.73963 3.25 8.1196 3.25137 6.8877 3.41699C5.67747 3.57972 4.9549 3.88886 4.42188 4.42188C3.88886 4.9549 3.57972 5.67747 3.41699 6.8877C3.25137 8.1196 3.25 9.73963 3.25 12C3.25 14.2604 3.25137 15.8804 3.41699 17.1123C3.57972 18.3225 3.88886 19.0451 4.42188 19.5781C4.9549 20.1111 5.67747 20.4203 6.8877 20.583C8.1196 20.7486 9.73963 20.75 12 20.75C14.2604 20.75 15.8804 20.7486 17.1123 20.583C18.3225 20.4203 19.0451 20.1111 19.5781 19.5781C20.1111 19.0451 20.4203 18.3225 20.583 17.1123C20.7486 15.8804 20.75 14.2604 20.75 12V10C20.75 9.58579 21.0858 9.25 21.5 9.25C21.9142 9.25 22.25 9.58579 22.25 10V12C22.25 14.2177 22.2515 15.9565 22.0693 17.3115C21.8842 18.6882 21.4969 19.7805 20.6387 20.6387C19.7805 21.4969 18.6882 21.8842 17.3115 22.0693C15.9565 22.2515 14.2177 22.25 12 22.25C9.78227 22.25 8.0435 22.2515 6.68848 22.0693C5.31182 21.8842 4.21953 21.4969 3.36133 20.6387C2.50313 19.7805 2.11575 18.6882 1.93066 17.3115C1.74854 15.9565 1.75 14.2177 1.75 12Z"
      fill="#2F54EB"
    />
    <path
      d="M20.4423 2.99804C20.7194 2.69019 21.194 2.66536 21.5019 2.94238C21.8098 3.21947 21.8347 3.69407 21.5576 4.00195L12.5576 14.0019C12.4199 14.1549 12.2251 14.2446 12.0195 14.25C11.8139 14.2553 11.6151 14.1757 11.4697 14.0303L7.96967 10.5303C7.67678 10.2374 7.67678 9.76261 7.96967 9.46972C8.26256 9.17683 8.73732 9.17683 9.03022 9.46972L11.9706 12.4101L20.4423 2.99804Z"
      fill="#2F54EB"
    />
  </svg>
);

export const StarIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.01404 0C9.42674 0 9.79738 0.253909 9.94666 0.638672L11.9193 5.72266L17.1058 6.12695C17.5055 6.15823 17.8482 6.4247 17.976 6.80469C18.1037 7.18487 17.9917 7.60476 17.6918 7.87109L13.681 11.4326L14.9398 16.7988C15.0331 17.1966 14.8749 17.6111 14.5404 17.8457C14.2059 18.0803 13.7625 18.0884 13.4203 17.8652L9.01404 14.9912L4.60779 17.8652C4.26552 18.0883 3.82215 18.0803 3.48767 17.8457C3.15318 17.611 2.99495 17.1966 3.08826 16.7988L4.34607 11.4326L0.336304 7.87109C0.036473 7.60476 -0.0756315 7.18484 0.052124 6.80469C0.179879 6.42472 0.522626 6.15829 0.922241 6.12695L6.10876 5.72266L8.08142 0.638672C8.23069 0.253934 8.60137 3.40895e-05 9.01404 0Z"
      fill="#FAAD14"
    />
  </svg>
);

const ProjectTeam = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6161 20H19.1063C20.2561 20 21.1707 19.4761 21.9919 18.7436C24.078 16.8826 19.1741 15 17.5 15M15.5 5.06877C15.7271 5.02373 15.9629 5 16.2048 5C18.0247 5 19.5 6.34315 19.5 8C19.5 9.65685 18.0247 11 16.2048 11C15.9629 11 15.7271 10.9763 15.5 10.9312"
      stroke="#2F54EB"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.48131 16.1112C3.30234 16.743 0.211137 18.0331 2.09388 19.6474C3.01359 20.436 4.03791 21 5.32572 21H12.6743C13.9621 21 14.9864 20.436 15.9061 19.6474C17.7889 18.0331 14.6977 16.743 13.5187 16.1112C10.754 14.6296 7.24599 14.6296 4.48131 16.1112Z"
      stroke="#2F54EB"
      strokeWidth="1.5"
    />
    <path
      d="M13 7.5C13 9.70914 11.2091 11.5 9 11.5C6.79086 11.5 5 9.70914 5 7.5C5 5.29086 6.79086 3.5 9 3.5C11.2091 3.5 13 5.29086 13 7.5Z"
      stroke="#2F54EB"
      strokeWidth="1.5"
    />
  </svg>
);

const BusinessModel = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 5L18 5"
      stroke="#2F54EB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10L14.5 14.5"
      stroke="#2F54EB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 11L5 18"
      stroke="#2F54EB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="6.44444"
      cy="6.44444"
      r="4.44444"
      stroke="#2F54EB"
      strokeWidth="1.5"
    />
    <circle cx="5" cy="20" r="2" stroke="#2F54EB" strokeWidth="1.5" />
    <circle cx="16" cy="16" r="2" stroke="#2F54EB" strokeWidth="1.5" />
    <circle cx="20" cy="5" r="2" stroke="#2F54EB" strokeWidth="1.5" />
  </svg>
);

const TargetIndicators = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7"
      stroke="#2F54EB"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14 2.20004C13.3538 2.06886 12.6849 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10"
      stroke="#2F54EB"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.4697 11.4697C11.1768 11.7626 11.1768 12.2374 11.4697 12.5303C11.7626 12.8232 12.2374 12.8232 12.5303 12.5303L12 12L11.4697 11.4697ZM19.6909 4.30912L18.9652 4.49846C19.0337 4.76115 19.2389 4.96628 19.5015 5.03482L19.6909 4.30912ZM19.1745 2.33007L18.4488 2.51942V2.51942L19.1745 2.33007ZM18.298 2.19006L18.8284 2.72039V2.72039L18.298 2.19006ZM17.1487 3.33944L16.6183 2.80911V2.80911L17.1487 3.33944ZM16.2781 6.15129L15.5524 6.34064L15.5524 6.34064L16.2781 6.15129ZM21.6699 4.82548L21.4806 5.55118V5.55118L21.6699 4.82548ZM21.8099 5.70196L21.2796 5.17163L21.2796 5.17163L21.8099 5.70196ZM20.6606 6.85135L21.1909 7.38168H21.1909L20.6606 6.85135ZM17.8487 7.72186L17.6594 8.44757L17.8487 7.72186ZM16.6031 7.39687L16.0728 6.86654L11.4697 11.4697L12 12L12.5303 12.5303L17.1335 7.9272L16.6031 7.39687ZM19.6909 4.30912L20.4166 4.11977L19.9002 2.14072L19.1745 2.33007L18.4488 2.51942L18.9652 4.49846L19.6909 4.30912ZM18.298 2.19006L17.7677 1.65973L16.6183 2.80911L17.1487 3.33944L17.679 3.86977L18.8284 2.72039L18.298 2.19006ZM16.2781 6.15129L15.5524 6.34064L15.8774 7.58622L16.6031 7.39687L17.3288 7.20752L17.0038 5.96194L16.2781 6.15129ZM19.6909 4.30912L19.5015 5.03482L21.4806 5.55118L21.6699 4.82548L21.8593 4.09977L19.8802 3.58341L19.6909 4.30912ZM21.8099 5.70196L21.2796 5.17163L20.1302 6.32102L20.6606 6.85135L21.1909 7.38168L22.3403 6.23229L21.8099 5.70196ZM17.8487 7.72186L18.0381 6.99616L16.7925 6.67117L16.6031 7.39687L16.4138 8.12258L17.6594 8.44757L17.8487 7.72186ZM20.6606 6.85135L20.1302 6.32102C19.5092 6.94201 18.6861 7.16524 18.0381 6.99616L17.8487 7.72186L17.6594 8.44757C18.8985 8.77087 20.2525 8.32009 21.1909 7.38168L20.6606 6.85135ZM21.6699 4.82548L21.4806 5.55118C21.4294 5.53782 21.371 5.5052 21.3242 5.45125C21.2797 5.39989 21.2597 5.34557 21.253 5.3035C21.2397 5.22031 21.2733 5.17792 21.2796 5.17163L21.8099 5.70196L22.3403 6.23229C22.6526 5.91996 22.8014 5.48764 22.7342 5.06688C22.6647 4.63188 22.3587 4.23007 21.8593 4.09977L21.6699 4.82548ZM17.1487 3.33944L16.6183 2.80911C15.6799 3.74753 15.2291 5.10151 15.5524 6.34064L16.2781 6.15129L17.0038 5.96194C16.8348 5.31391 17.058 4.49077 17.679 3.86977L17.1487 3.33944ZM19.1745 2.33007L19.9002 2.14072C19.7699 1.64133 19.3681 1.33528 18.9331 1.26579C18.5124 1.19858 18.08 1.3474 17.7677 1.65973L18.298 2.19006L18.8284 2.72039C18.8221 2.72667 18.7797 2.7603 18.6965 2.74701C18.6544 2.74029 18.6001 2.72026 18.5487 2.67576C18.4948 2.62902 18.4622 2.57065 18.4488 2.51942L19.1745 2.33007Z"
      fill="#2F54EB"
    />
  </svg>
);

export const clusterIconsDict = {
  project_team: ProjectTeam,
  business_model: BusinessModel,
  target_indicators: TargetIndicators,
};

export const SmallTableIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_180141_1726)">
      <rect width="14" height="14" fill="white" />
      <path
        d="M6.99976 1.02048C8.2933 1.02048 9.308 1.01974 10.0984 1.12595C10.9014 1.23391 11.5392 1.46029 12.0398 1.96091C12.5402 2.46141 12.7658 3.09858 12.8738 3.90134C12.98 4.69174 12.9792 5.70635 12.9792 6.99997C12.9792 8.29365 12.98 9.30817 12.8738 10.0986C12.7658 10.9014 12.5402 11.5385 12.0398 12.039C11.5392 12.5396 10.9014 12.766 10.0984 12.874C9.30799 12.9802 8.29331 12.9795 6.99976 12.9795C5.70646 12.9795 4.69239 12.9802 3.9021 12.874C3.09905 12.766 2.46131 12.5396 1.96069 12.039C1.46031 11.5385 1.23467 10.9014 1.12671 10.0986C1.02047 9.30817 1.02124 8.29365 1.02124 6.99997C1.02124 5.70634 1.02047 4.69174 1.12671 3.90134C1.23468 3.09856 1.46028 2.46142 1.96069 1.96091C2.46131 1.46029 3.09905 1.23391 3.9021 1.12595C4.69239 1.01976 5.70647 1.02048 6.99976 1.02048ZM1.91675 5.10446C1.89936 5.63572 1.89624 6.25878 1.89624 6.99997C1.89624 8.31852 1.89728 9.26378 1.9939 9.98239C2.08883 10.6882 2.26893 11.11 2.57983 11.4209C2.89074 11.7317 3.31251 11.9119 4.01831 12.0068C4.7368 12.1034 5.68161 12.1045 6.99976 12.1045C8.31819 12.1045 9.26359 12.1034 9.98218 12.0068C10.688 11.9119 11.1097 11.7317 11.4207 11.4209C11.7316 11.11 11.9117 10.6882 12.0066 9.98239C12.1032 9.26378 12.1042 8.31852 12.1042 6.99997C12.1042 6.25878 12.1011 5.63572 12.0837 5.10446H1.91675ZM4.66675 9.47946C4.90837 9.47946 5.10425 9.67534 5.10425 9.91696C5.10416 10.1585 4.90832 10.3545 4.66675 10.3545H4.08374C3.84217 10.3545 3.64632 10.1585 3.64624 9.91696C3.64624 9.67534 3.84212 9.47946 4.08374 9.47946H4.66675ZM9.91675 9.47946C10.1584 9.47946 10.3542 9.67534 10.3542 9.91696C10.3542 10.1585 10.1583 10.3545 9.91675 10.3545H6.41675C6.17519 10.3544 5.97933 10.1585 5.97925 9.91696C5.97925 9.67535 6.17514 9.47948 6.41675 9.47946H9.91675ZM4.66675 7.14645C4.90837 7.14645 5.10425 7.34233 5.10425 7.58395C5.10399 7.82536 4.90821 8.02145 4.66675 8.02145H4.08374C3.84228 8.02145 3.6465 7.82536 3.64624 7.58395C3.64624 7.34233 3.84212 7.14645 4.08374 7.14645H4.66675ZM9.91675 7.14645C10.1584 7.14645 10.3542 7.34233 10.3542 7.58395C10.354 7.82536 10.1582 8.02145 9.91675 8.02145H6.41675C6.1753 8.02143 5.97951 7.82534 5.97925 7.58395C5.97925 7.34234 6.17514 7.14647 6.41675 7.14645H9.91675ZM6.99976 1.89548C5.68162 1.89548 4.7368 1.89657 4.01831 1.99313C3.31259 2.08803 2.89073 2.26834 2.57983 2.57907C2.26897 2.88994 2.08884 3.31183 1.9939 4.01755C1.9847 4.08594 1.97702 4.15684 1.96948 4.22946H12.031C12.0235 4.15684 12.0158 4.08594 12.0066 4.01755C11.9117 3.31182 11.7315 2.88994 11.4207 2.57907C11.1098 2.26831 10.6879 2.08803 9.98218 1.99313C9.2636 1.89655 8.31817 1.89548 6.99976 1.89548Z"
        fill="#2F54EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_180141_1726">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InfoCircle = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_180255_1425)">
      <path
        d="M8 0.833939C11.958 0.833941 15.1669 4.04199 15.167 7.99995C15.167 11.958 11.958 15.1669 8 15.1669C4.04196 15.1669 0.833008 11.958 0.833008 7.99995C0.833099 4.04199 4.04202 0.833939 8 0.833939ZM8 1.83394C4.5943 1.83394 1.8331 4.59428 1.83301 7.99995C1.83301 11.4057 4.59424 14.1669 8 14.1669C11.4058 14.1669 14.167 11.4057 14.167 7.99995C14.1669 4.59428 11.4057 1.83394 8 1.83394ZM7.51758 6.83296C7.65419 6.83291 7.80202 6.83381 7.92676 6.85054C8.07285 6.87018 8.25988 6.92022 8.41699 7.0771C8.57404 7.23415 8.62483 7.42119 8.64453 7.56734C8.66131 7.69215 8.66119 7.84075 8.66113 7.97749V11.3339C8.66087 11.6099 8.43711 11.8339 8.16113 11.8339C7.8853 11.8338 7.66139 11.6098 7.66113 11.3339V7.83394C7.61491 7.83319 7.56102 7.83394 7.49512 7.83394C7.21914 7.83394 6.99538 7.60986 6.99512 7.33394C6.99512 7.0578 7.21897 6.83394 7.49512 6.83394C7.50257 6.83394 7.51006 6.83296 7.51758 6.83296ZM8.00098 4.66695C8.36902 4.66712 8.66699 4.96586 8.66699 5.33394C8.66673 5.7018 8.36885 5.99978 8.00098 5.99995H7.99512C7.62709 5.99995 7.32839 5.70191 7.32812 5.33394C7.32812 4.96575 7.62693 4.66695 7.99512 4.66695H8.00098Z"
        fill="#2F54EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_180255_1425">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ChartTableIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.16695C9.47848 1.16695 10.6377 1.16565 11.541 1.28706C12.4587 1.41045 13.1867 1.66909 13.7588 2.24117C14.3309 2.81326 14.5895 3.54124 14.7129 4.45894C14.8343 5.36225 14.833 6.52155 14.833 7.99995C14.833 9.47835 14.8343 10.6376 14.7129 11.541C14.5895 12.4587 14.3309 13.1876 13.7588 13.7597C13.1867 14.3316 12.4586 14.5895 11.541 14.7128C10.6377 14.8343 9.47849 14.8339 8 14.8339C6.52151 14.8339 5.36233 14.8343 4.45898 14.7128C3.54144 14.5895 2.81328 14.3316 2.24121 13.7597C1.66908 13.1876 1.4105 12.4587 1.28711 11.541C1.16571 10.6376 1.16699 9.47835 1.16699 7.99995C1.16699 6.52155 1.1657 5.36225 1.28711 4.45894C1.41051 3.54124 1.66911 2.81326 2.24121 2.24117C2.81333 1.66909 3.54126 1.41045 4.45898 1.28706C5.36233 1.16565 6.52153 1.16695 8 1.16695ZM8 2.16695C6.49308 2.16695 5.41306 2.16786 4.5918 2.27827C3.78506 2.38675 3.30358 2.5929 2.94824 2.9482C2.59293 3.30351 2.38681 3.78506 2.27832 4.59175C2.16791 5.41299 2.16699 6.49313 2.16699 7.99995C2.16699 9.5068 2.16792 10.5869 2.27832 11.4082C2.38681 12.215 2.5929 12.6973 2.94824 13.0527C3.30355 13.4078 3.78529 13.6142 4.5918 13.7226C5.41306 13.833 6.49312 13.8339 8 13.8339C9.50688 13.8339 10.5869 13.833 11.4082 13.7226C12.2147 13.6142 12.6964 13.4078 13.0518 13.0527C13.4071 12.6973 13.6132 12.215 13.7217 11.4082C13.8321 10.5869 13.833 9.5068 13.833 7.99995C13.833 6.49313 13.8321 5.41299 13.7217 4.59175C13.6132 3.78506 13.4071 3.30351 13.0518 2.9482C12.6964 2.5929 12.2149 2.38675 11.4082 2.27827C10.5869 2.16786 9.50691 2.16695 8 2.16695ZM4.66699 8.16695C4.94298 8.16712 5.16699 8.39091 5.16699 8.66695V11.3339C5.16673 11.6097 4.94282 11.8338 4.66699 11.8339C4.39101 11.8339 4.16725 11.6099 4.16699 11.3339V8.66695C4.16699 8.3908 4.39085 8.16695 4.66699 8.16695ZM8 4.16695C8.27614 4.16695 8.5 4.39081 8.5 4.66695V11.3339C8.49974 11.6099 8.27598 11.8339 8 11.8339C7.72402 11.8339 7.50026 11.6099 7.5 11.3339V4.66695C7.5 4.3908 7.72386 4.16695 8 4.16695ZM11.333 6.83394C11.6092 6.83394 11.833 7.0578 11.833 7.33394V11.3339C11.8327 11.6099 11.609 11.8339 11.333 11.8339C11.0572 11.8338 10.8333 11.6098 10.833 11.3339V7.33394C10.833 7.0579 11.057 6.83411 11.333 6.83394Z"
      fill="#2F54EB"
    />
  </svg>
);

export const ChartNewIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66699 1.16695C8.94298 1.16712 9.16698 1.39092 9.16699 1.66695C9.16691 1.9429 8.94293 2.16676 8.66699 2.16695H8C6.49308 2.16695 5.41306 2.16786 4.5918 2.27827C3.78506 2.38675 3.30358 2.59291 2.94824 2.9482C2.59293 3.30351 2.38682 3.78507 2.27832 4.59175C2.16791 5.41298 2.16699 6.49314 2.16699 7.99995C2.16699 9.5068 2.16792 10.5869 2.27832 11.4082C2.38681 12.215 2.5929 12.6973 2.94824 13.0527C3.30355 13.4078 3.78529 13.6142 4.5918 13.7226C5.41306 13.833 6.49313 13.8339 8 13.8339C9.50688 13.8339 10.5869 13.833 11.4082 13.7226C12.2147 13.6142 12.6965 13.4078 13.0518 13.0527C13.4071 12.6973 13.6132 12.215 13.7217 11.4082C13.8321 10.5869 13.833 9.5068 13.833 7.99995C13.833 7.78154 13.8328 7.61632 13.832 7.50581C13.8317 7.45076 13.8313 7.40838 13.8311 7.38081V7.34077C13.8274 7.06484 14.0474 6.83786 14.3232 6.83394C14.5994 6.83031 14.8264 7.05098 14.8301 7.3271V7.33003C14.8301 7.33185 14.831 7.33455 14.8311 7.33784C14.8311 7.34513 14.8309 7.35681 14.8311 7.37105C14.8313 7.39963 14.8317 7.44212 14.832 7.498C14.8328 7.61069 14.833 7.77876 14.833 7.99995C14.833 9.47834 14.8343 10.6377 14.7129 11.541C14.5895 12.4587 14.3309 13.1876 13.7588 13.7597C13.1867 14.3316 12.4586 14.5895 11.541 14.7128C10.6377 14.8343 9.47849 14.8339 8 14.8339C6.52151 14.8339 5.36233 14.8343 4.45898 14.7128C3.54144 14.5895 2.81328 14.3316 2.24121 13.7597C1.66909 13.1876 1.4105 12.4587 1.28711 11.541C1.16572 10.6377 1.16699 9.47834 1.16699 7.99995C1.16699 6.52155 1.16569 5.36225 1.28711 4.45894C1.41051 3.54124 1.66911 2.81326 2.24121 2.24117C2.81333 1.6691 3.54126 1.41045 4.45898 1.28706C5.36233 1.16565 6.52153 1.16695 8 1.16695H8.66699ZM4.33301 9.16695C4.60915 9.16695 4.83301 9.3908 4.83301 9.66695V11.6669C4.83292 11.943 4.6091 12.1669 4.33301 12.1669C4.05707 12.1668 3.83309 11.9429 3.83301 11.6669V9.66695C3.83301 9.39091 4.05701 9.16712 4.33301 9.16695ZM7.66699 5.16695C7.94298 5.16712 8.16699 5.39091 8.16699 5.66695V11.6669C8.16691 11.9429 7.94293 12.1668 7.66699 12.1669C7.3909 12.1669 7.16708 11.943 7.16699 11.6669V5.66695C7.16699 5.3908 7.39085 5.16695 7.66699 5.16695ZM11 8.49995C11.2761 8.49996 11.4999 8.72389 11.5 8.99995V11.6669C11.4999 11.943 11.2761 12.1669 11 12.1669C10.7239 12.1669 10.5001 11.943 10.5 11.6669V8.99995C10.5001 8.72389 10.7239 8.49995 11 8.49995ZM12.333 1.16695C13.7137 1.16695 14.833 2.28623 14.833 3.66695C14.8329 5.04759 13.7137 6.16695 12.333 6.16695C10.9525 6.16677 9.83309 5.04748 9.83301 3.66695C9.83301 2.28634 10.9524 1.16712 12.333 1.16695ZM12.333 2.16695C11.5047 2.16712 10.833 2.83863 10.833 3.66695C10.8331 4.49519 11.5048 5.16677 12.333 5.16695C13.1614 5.16695 13.8329 4.4953 13.833 3.66695C13.833 2.83852 13.1614 2.16695 12.333 2.16695Z"
      fill="#2F54EB"
    />
  </svg>
);

export const ChartGrowIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_180255_1533)">
      <rect width="16" height="16" fill="white" />
      <path
        d="M8 1.16695C9.47848 1.16695 10.6377 1.16565 11.541 1.28706C12.4587 1.41045 13.1867 1.66909 13.7588 2.24117C14.3309 2.81326 14.5895 3.54124 14.7129 4.45894C14.8343 5.36225 14.833 6.52155 14.833 7.99995C14.833 9.47835 14.8343 10.6376 14.7129 11.541C14.5895 12.4587 14.3309 13.1876 13.7588 13.7597C13.1867 14.3316 12.4586 14.5895 11.541 14.7128C10.6377 14.8343 9.47849 14.8339 8 14.8339C6.52151 14.8339 5.36233 14.8343 4.45898 14.7128C3.54144 14.5895 2.81328 14.3316 2.24121 13.7597C1.66908 13.1876 1.4105 12.4587 1.28711 11.541C1.16571 10.6376 1.16699 9.47835 1.16699 7.99995C1.16699 6.52155 1.1657 5.36225 1.28711 4.45894C1.41051 3.54124 1.66911 2.81326 2.24121 2.24117C2.81333 1.66909 3.54126 1.41045 4.45898 1.28706C5.36233 1.16565 6.52153 1.16695 8 1.16695ZM8 2.16695C6.49308 2.16695 5.41306 2.16786 4.5918 2.27827C3.78506 2.38675 3.30358 2.5929 2.94824 2.9482C2.59293 3.30351 2.38681 3.78506 2.27832 4.59175C2.16791 5.41299 2.16699 6.49313 2.16699 7.99995C2.16699 9.5068 2.16792 10.5869 2.27832 11.4082C2.38681 12.215 2.5929 12.6973 2.94824 13.0527C3.30355 13.4078 3.78529 13.6142 4.5918 13.7226C5.41306 13.833 6.49312 13.8339 8 13.8339C9.50688 13.8339 10.5869 13.833 11.4082 13.7226C12.2147 13.6142 12.6964 13.4078 13.0518 13.0527C13.4071 12.6973 13.6132 12.215 13.7217 11.4082C13.8321 10.5869 13.833 9.5068 13.833 7.99995C13.833 6.49313 13.8321 5.41299 13.7217 4.59175C13.6132 3.78506 13.4071 3.30351 13.0518 2.9482C12.6964 2.5929 12.2149 2.38675 11.4082 2.27827C10.5869 2.16786 9.50691 2.16695 8 2.16695ZM4.66699 10.1669C4.94298 10.1671 5.16699 10.3909 5.16699 10.6669V12C5.16699 12.276 4.94298 12.4998 4.66699 12.5C4.39085 12.5 4.16699 12.2761 4.16699 12V10.6669C4.16699 10.3908 4.39085 10.1669 4.66699 10.1669ZM8 9.49995C8.27609 9.49996 8.49991 9.72389 8.5 9.99995V12C8.5 12.2761 8.27614 12.5 8 12.5C7.72386 12.5 7.5 12.2761 7.5 12V9.99995C7.50009 9.72389 7.72391 9.49995 8 9.49995ZM11.333 8.16695C11.6092 8.16695 11.833 8.3908 11.833 8.66695V12C11.833 12.2761 11.6092 12.5 11.333 12.5C11.057 12.4998 10.833 12.276 10.833 12V8.66695C10.833 8.39091 11.057 8.16712 11.333 8.16695ZM10.5723 3.50191C10.7265 3.49487 10.913 3.50886 11.0967 3.61324C11.287 3.72146 11.3932 3.87939 11.46 4.0273C11.5179 4.15572 11.5621 4.31382 11.6025 4.45503L11.8135 5.19527C11.8895 5.46056 11.7368 5.73814 11.4717 5.81441C11.2064 5.89042 10.9288 5.73685 10.8525 5.47163L10.7539 5.12788C9.2648 7.26943 6.88173 8.16695 4 8.16695C3.72391 8.16695 3.50009 7.94302 3.5 7.66695C3.5 7.3908 3.72386 7.16695 4 7.16695C6.63469 7.16695 8.64048 6.37136 9.89551 4.61031L9.41504 4.69038C9.14267 4.73529 8.88489 4.5506 8.83984 4.27827C8.7949 4.00581 8.97949 3.74802 9.25195 3.70308L10.0967 3.56441C10.2621 3.53711 10.4298 3.50844 10.5723 3.50191Z"
        fill="#2F54EB"
      />
    </g>
    <defs>
      <clipPath id="clip0_180255_1533">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PeopleLightBlue = (
  <svg
    width="123"
    height="85"
    viewBox="0 0 123 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M115.81 49.7129L76.4487 75.4604C68.067 80.9503 54.4198 80.9503 45.9812 75.4604L6.35875 49.7257C2.10536 46.9616 -0.00997147 43.3401 0.00140123 39.7313V44.8501C-0.0213442 48.4716 2.10535 52.0932 6.34737 54.8445L45.9699 80.5792C54.4084 86.069 68.0443 86.069 76.4373 80.5792L115.798 54.8317C119.961 52.106 122.053 48.5484 122.053 44.9781V39.8593C122.053 43.4296 119.972 47 115.81 49.7129Z"
      fill="#40A9FF"
    />
    <path
      d="M115.707 29.8521C124.146 35.342 124.191 44.223 115.81 49.7129L76.4488 75.4604C68.0671 80.9503 54.4199 80.9503 45.9814 75.4604L6.35888 49.7257C-2.07966 44.2358 -2.12515 35.3548 6.25653 29.8649L45.6174 4.11742C53.9991 -1.37247 67.6463 -1.37247 76.0849 4.11742L115.707 29.8649V29.8521Z"
      fill="#F5FBFF"
    />
    <path
      d="M53.4427 60.927V47.5172C51.9246 46.7582 50.9126 44.9871 50.9126 43.216V33.0954C50.9126 31.3243 51.9246 29.8062 53.4427 28.7941V28.0351C53.4427 25.2519 51.1656 22.9748 48.3824 22.9748C45.5993 22.9748 43.3221 25.2519 43.3221 28.0351C43.3221 30.8183 45.5993 33.0954 48.3824 33.0954H43.3221C42.0571 33.0954 40.792 34.3605 40.792 35.6255V45.7461C40.792 47.0112 42.0571 48.2762 43.3221 48.2762V60.927H53.4427ZM78.7441 33.0954H73.6838C76.467 33.0954 78.7441 30.8183 78.7441 28.0351C78.7441 25.2519 76.467 22.9748 73.6838 22.9748C70.9007 22.9748 68.6236 25.2519 68.6236 28.0351V28.7941C70.1416 29.8062 71.1537 31.3243 71.1537 33.0954V43.216C71.1537 44.9871 70.1416 46.7582 68.6236 47.5172V60.927H78.7441V48.2762C80.0092 48.2762 81.2743 47.0112 81.2743 45.7461V35.6255C81.2743 34.3605 80.0092 33.0954 78.7441 33.0954ZM66.0934 25.505C66.1087 26.1788 65.9891 26.849 65.7418 27.476C65.4945 28.103 65.1244 28.6744 64.6532 29.1564C64.1821 29.6384 63.6194 30.0215 62.9982 30.2831C62.377 30.5446 61.7097 30.6795 61.0357 30.6796C60.3616 30.6798 59.6943 30.5453 59.073 30.2841C58.4516 30.0228 57.8888 29.64 57.4174 29.1582C56.946 28.6764 56.5756 28.1053 56.328 27.4784C56.0804 26.8514 55.9605 26.1814 55.9754 25.5075C56.0046 24.1853 56.5503 22.9272 57.4956 22.0023C58.4409 21.0775 59.7107 20.5594 61.0332 20.5591C62.3556 20.5588 63.6257 21.0762 64.5714 22.0005C65.5172 22.9249 66.0635 24.1828 66.0934 25.505Z"
      fill="#40A9FF"
    />
    <path
      d="M66.0933 30.5652H55.9728C54.7077 30.5652 53.4426 31.8303 53.4426 33.0954V43.216C53.4426 44.481 54.7077 45.7461 55.9728 45.7461V60.927H66.0933V45.7461C67.3584 45.7461 68.6235 44.481 68.6235 43.216V33.0954C68.6235 31.8303 67.3584 30.5652 66.0933 30.5652Z"
      fill="#40A9FF"
    />
  </svg>
);

export const PeopleBlue = (
  <svg
    width="123"
    height="85"
    viewBox="0 0 123 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M115.81 49.7129L76.4488 75.4604C68.0671 80.9502 54.4199 80.9502 45.9813 75.4604L6.35887 49.7257C2.10548 46.9616 -0.0098494 43.34 0.0015233 39.7313V44.8501C-0.0212221 48.4716 2.10547 52.0931 6.34749 54.8445L45.97 80.5791C54.4085 86.069 68.0444 86.069 76.4374 80.5791L115.798 54.8317C119.961 52.1059 122.053 48.5484 122.053 44.9781V39.8593C122.053 43.4296 119.972 47 115.81 49.7129Z"
      fill="#2F54EB"
    />
    <path
      d="M115.707 29.8521C124.146 35.342 124.191 44.223 115.81 49.7129L76.4488 75.4604C68.0671 80.9503 54.4199 80.9503 45.9814 75.4604L6.35888 49.7257C-2.07966 44.2358 -2.12515 35.3548 6.25653 29.8649L45.6174 4.11742C53.9991 -1.37247 67.6463 -1.37247 76.0849 4.11742L115.707 29.8649V29.8521Z"
      fill="#F5FBFF"
    />
    <path
      d="M53.4427 60.9269V47.5172C51.9246 46.7581 50.9126 44.987 50.9126 43.2159V33.0954C50.9126 31.3243 51.9246 29.8062 53.4427 28.7941V28.0351C53.4427 25.2519 51.1656 22.9748 48.3824 22.9748C45.5993 22.9748 43.3221 25.2519 43.3221 28.0351C43.3221 30.8182 45.5993 33.0954 48.3824 33.0954H43.3221C42.0571 33.0954 40.792 34.3604 40.792 35.6255V45.7461C40.792 47.0111 42.0571 48.2762 43.3221 48.2762V60.9269H53.4427ZM78.7441 33.0954H73.6838C76.467 33.0954 78.7441 30.8182 78.7441 28.0351C78.7441 25.2519 76.467 22.9748 73.6838 22.9748C70.9007 22.9748 68.6236 25.2519 68.6236 28.0351V28.7941C70.1416 29.8062 71.1537 31.3243 71.1537 33.0954V43.2159C71.1537 44.987 70.1416 46.7581 68.6236 47.5172V60.9269H78.7441V48.2762C80.0092 48.2762 81.2743 47.0111 81.2743 45.7461V35.6255C81.2743 34.3604 80.0092 33.0954 78.7441 33.0954ZM66.0934 25.5049C66.1087 26.1788 65.9891 26.8489 65.7418 27.476C65.4945 28.103 65.1244 28.6743 64.6532 29.1564C64.1821 29.6384 63.6194 30.0215 62.9982 30.283C62.377 30.5446 61.7097 30.6795 61.0357 30.6796C60.3616 30.6798 59.6943 30.5453 59.073 30.284C58.4516 30.0228 57.8888 29.64 57.4174 29.1582C56.946 28.6764 56.5756 28.1053 56.328 27.4783C56.0804 26.8514 55.9605 26.1814 55.9754 25.5075C56.0046 24.1853 56.5503 22.9271 57.4956 22.0023C58.4409 21.0774 59.7107 20.5594 61.0332 20.5591C62.3556 20.5587 63.6257 21.0761 64.5714 22.0005C65.5172 22.9249 66.0635 24.1828 66.0934 25.5049Z"
      fill="#2F54EB"
    />
    <path
      d="M66.0933 30.5652H55.9728C54.7077 30.5652 53.4426 31.8303 53.4426 33.0954V43.2159C53.4426 44.481 54.7077 45.7461 55.9728 45.7461V60.9269H66.0933V45.7461C67.3584 45.7461 68.6235 44.481 68.6235 43.2159V33.0954C68.6235 31.8303 67.3584 30.5652 66.0933 30.5652Z"
      fill="#2F54EB"
    />
  </svg>
);

export const PeoplePurple = (
  <svg
    width="123"
    height="85"
    viewBox="0 0 123 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M115.81 49.7129L76.4488 75.4604C68.0671 80.9503 54.4199 80.9503 45.9813 75.4604L6.35887 49.7257C2.10548 46.9616 -0.0098494 43.3401 0.0015233 39.7313V44.8501C-0.0212221 48.4716 2.10547 52.0932 6.34749 54.8445L45.97 80.5792C54.4085 86.069 68.0444 86.069 76.4374 80.5792L115.798 54.8317C119.961 52.106 122.053 48.5484 122.053 44.9781V39.8593C122.053 43.4296 119.972 47 115.81 49.7129Z"
      fill="#852DEE"
    />
    <path
      d="M115.707 29.8521C124.146 35.342 124.191 44.223 115.81 49.7129L76.4488 75.4604C68.0671 80.9503 54.4199 80.9503 45.9814 75.4604L6.35888 49.7257C-2.07966 44.2358 -2.12515 35.3548 6.25653 29.8649L45.6174 4.11742C53.9991 -1.37247 67.6463 -1.37247 76.0849 4.11742L115.707 29.8649V29.8521Z"
      fill="#F5FBFF"
    />
    <path
      d="M53.4427 60.927V47.5172C51.9246 46.7582 50.9126 44.9871 50.9126 43.216V33.0954C50.9126 31.3243 51.9246 29.8062 53.4427 28.7941V28.0351C53.4427 25.2519 51.1656 22.9748 48.3824 22.9748C45.5993 22.9748 43.3221 25.2519 43.3221 28.0351C43.3221 30.8183 45.5993 33.0954 48.3824 33.0954H43.3221C42.0571 33.0954 40.792 34.3605 40.792 35.6255V45.7461C40.792 47.0112 42.0571 48.2762 43.3221 48.2762V60.927H53.4427ZM78.7441 33.0954H73.6838C76.467 33.0954 78.7441 30.8183 78.7441 28.0351C78.7441 25.2519 76.467 22.9748 73.6838 22.9748C70.9007 22.9748 68.6236 25.2519 68.6236 28.0351V28.7941C70.1416 29.8062 71.1537 31.3243 71.1537 33.0954V43.216C71.1537 44.9871 70.1416 46.7582 68.6236 47.5172V60.927H78.7441V48.2762C80.0092 48.2762 81.2743 47.0112 81.2743 45.7461V35.6255C81.2743 34.3605 80.0092 33.0954 78.7441 33.0954ZM66.0934 25.505C66.1087 26.1788 65.9891 26.849 65.7418 27.476C65.4945 28.103 65.1244 28.6744 64.6532 29.1564C64.1821 29.6384 63.6194 30.0215 62.9982 30.2831C62.377 30.5446 61.7097 30.6795 61.0357 30.6796C60.3616 30.6798 59.6943 30.5453 59.073 30.2841C58.4516 30.0228 57.8888 29.64 57.4174 29.1582C56.946 28.6764 56.5756 28.1053 56.328 27.4784C56.0804 26.8514 55.9605 26.1814 55.9754 25.5075C56.0046 24.1853 56.5503 22.9272 57.4956 22.0023C58.4409 21.0775 59.7107 20.5594 61.0332 20.5591C62.3556 20.5588 63.6257 21.0762 64.5714 22.0005C65.5172 22.9249 66.0635 24.1828 66.0934 25.505Z"
      fill="#852DEE"
    />
    <path
      d="M66.0933 30.5652H55.9728C54.7077 30.5652 53.4426 31.8303 53.4426 33.0954V43.216C53.4426 44.481 54.7077 45.7461 55.9728 45.7461V60.927H66.0933V45.7461C67.3584 45.7461 68.6235 44.481 68.6235 43.216V33.0954C68.6235 31.8303 67.3584 30.5652 66.0933 30.5652Z"
      fill="#852DEE"
    />
  </svg>
);

export function StratArrow({ fill, className }) {
  return (
    <svg
      width="250"
      height="140"
      viewBox="0 0 231 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M231 63.891L205.099 0H0L25.9006 63.891L0 127.782H205.099L231 63.891Z"
        fill={fill ?? '#597EF7'}
      />
    </svg>
  );
}

export const MinerIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8575 22.941C14.5182 22.3774 15.3563 21.8631 15.7073 22.4161L16.3873 23.5159L18.192 22.0462L17.0771 15.8472L14.0076 19.1816L11.398 19.4766C11.2531 19.4916 11.1181 19.5765 11.0381 19.6966L9.55833 21.9412L10.7831 24.4908C10.8281 24.5858 10.8431 24.6958 10.8231 24.8007L10.4382 26.9104C10.3082 27.5538 9.34356 27.385 9.45337 26.7304L9.81329 24.7807L8.79847 22.6861L5.05905 24.1308C4.94908 24.1758 4.8591 24.2508 4.80409 24.3558L2.06954 29.255C1.87673 29.5695 2.1348 30.0112 2.50449 29.9999L13.3827 29.9999L15.7024 24.3108L14.8575 22.941Z"
      fill="#597EF7"
    />
    <path
      d="M20.8664 18.0017C20.8364 17.9167 20.7814 17.8467 20.7114 17.7967L18.0718 15.7271L19.2267 22.161C19.2617 22.336 19.1917 22.5209 19.0517 22.6359L16.677 24.5706L14.4624 29.9998H21.8662C22.0212 29.9998 22.1662 29.9298 22.2612 29.8098C22.3562 29.6898 22.3912 29.5348 22.3562 29.3848L21.6112 26.2653L22.8861 23.3108C22.9411 23.1858 22.9411 23.0459 22.8911 22.9209L20.8664 18.0017Z"
      fill="#597EF7"
    />
    <path
      d="M10.3533 17.1019C10.5735 17.1759 10.8161 17.0779 10.9382 16.8769C12.298 14.5223 13.9077 12.3276 15.7324 10.323L16.3423 10.9279C16.7072 11.3039 17.3113 11.2947 17.6771 10.9279L18.017 10.5879C18.2289 10.3732 18.7241 9.88291 18.9318 9.67305C19.2882 9.31572 19.2991 8.70594 18.9269 8.34328L18.322 7.73336C20.3267 5.90867 22.5213 4.29891 24.8759 2.93914C25.3262 2.69436 25.1009 1.93623 24.5809 2.00431C16.8072 2.67917 10.6782 8.80819 10.0033 16.5819C9.98332 16.8169 10.1283 17.0319 10.3533 17.1019Z"
      fill="#597EF7"
    />
    <path
      d="M29.4399 18.9017L25.5517 15.2248C22.9373 12.7525 19.9664 9.94312 19.9664 9.94312C19.8815 10.1031 19.7665 10.2531 19.6365 10.383C19.3292 10.6609 18.304 11.7911 17.9468 11.9678L20.6663 14.8473L26.9003 21.4413C27.2353 21.7962 27.6902 21.9912 28.1751 22.0012C29.7764 22.0661 30.6274 19.9773 29.4399 18.9017Z"
      fill="#597EF7"
    />
  </svg>
);

export const CarrierIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.565 26.846C14.565 25.1105 13.1535 23.699 11.418 23.699C9.68251 23.699 8.27051 25.111 8.27051 26.846C8.27051 28.581 9.68251 29.993 11.418 29.993C13.1535 29.993 14.565 28.5815 14.565 26.846ZM9.38151 26.846C9.38151 25.723 10.295 24.8095 11.418 24.8095C12.541 24.8095 13.4545 25.723 13.4545 26.846C13.4545 27.969 12.541 28.8825 11.418 28.8825C10.295 28.8825 9.38151 27.969 9.38151 26.846Z"
      fill="#2F54EB"
    />
    <path
      d="M6.3335 15.3674L6.971 24.6649C6.999 25.0724 7.162 25.4499 7.4235 25.7439C7.908 23.9909 9.5125 22.6989 11.4175 22.6989C13.5345 22.6989 15.2825 24.2939 15.531 26.3449H16.468C16.7165 24.2939 18.465 22.6989 20.5815 22.6989C22.4855 22.6989 24.089 23.9894 24.575 25.7404C24.836 25.4464 24.999 25.0699 25.0265 24.6649L25.664 15.3674H6.3335Z"
      fill="#2F54EB"
    />
    <path
      d="M20.5819 27.8826C21.1544 27.8826 21.6184 27.4185 21.6184 26.8461C21.6184 26.2736 21.1544 25.8096 20.5819 25.8096C20.0095 25.8096 19.5454 26.2736 19.5454 26.8461C19.5454 27.4185 20.0095 27.8826 20.5819 27.8826Z"
      fill="#2F54EB"
    />
    <path
      d="M11.4178 27.8826C11.9903 27.8826 12.4543 27.4185 12.4543 26.8461C12.4543 26.2736 11.9903 25.8096 11.4178 25.8096C10.8454 25.8096 10.3813 26.2736 10.3813 26.8461C10.3813 27.4185 10.8454 27.8826 11.4178 27.8826Z"
      fill="#2F54EB"
    />
    <path
      d="M26.4766 14.3675C27.1006 14.3675 27.6081 13.86 27.6081 13.236C27.6081 12.612 27.1006 12.1045 26.4766 12.1045H25.8651H25.8636H25.8621H5.52359C4.89959 12.1045 4.39209 12.612 4.39209 13.236C4.39209 13.86 4.89959 14.3675 5.52359 14.3675H26.4766Z"
      fill="#2F54EB"
    />
    <path
      d="M13.9622 3.67253C13.4477 3.88803 12.9622 4.09103 12.4952 4.34053C11.8317 4.69553 11.4447 5.05203 11.2787 5.46303C11.1887 5.68553 11.1562 5.95003 11.1217 6.22953C11.1022 6.38703 11.0822 6.54503 11.0532 6.70003C10.8682 7.69403 10.3007 8.61603 9.49569 9.22903C9.11819 9.51703 8.71119 9.73853 8.31719 9.95303C8.08019 10.0815 7.84369 10.21 7.61619 10.353C7.16469 10.6365 6.95869 10.8965 6.86719 11.1045H25.1587C24.7227 9.88603 24.1527 8.60653 23.6302 7.47103C23.2812 6.71353 22.8862 5.93603 22.2307 5.48153C21.9347 5.27603 21.5802 5.13353 21.2052 4.98203C20.6732 4.76803 20.1227 4.54653 19.6667 4.11803C19.3427 3.81353 19.1107 3.44653 18.8857 3.09103C18.5827 2.61153 18.3202 2.19753 17.9172 2.05803C17.3652 1.86653 16.7037 2.26353 16.0652 2.64603L15.7697 2.82153C15.1832 3.16153 14.5622 3.42153 13.9617 3.67303L13.9622 3.67253Z"
      fill="#2F54EB"
    />
    <path
      d="M20.582 29.993C22.3175 29.993 23.7295 28.5815 23.7295 26.846C23.7295 26.779 23.7235 26.7135 23.7195 26.648C23.7195 26.6455 23.7195 26.6435 23.7195 26.641C23.613 25.0015 22.2485 23.699 20.5825 23.699C18.85 23.699 17.4405 25.1065 17.436 26.8375C17.436 26.84 17.4375 26.8425 17.4375 26.845C17.4375 26.848 17.436 26.85 17.436 26.853C17.44 28.585 18.849 29.993 20.582 29.993ZM20.582 24.8095C21.705 24.8095 22.6185 25.723 22.6185 26.846C22.6185 27.969 21.705 28.8825 20.582 28.8825C19.459 28.8825 18.5455 27.969 18.5455 26.846C18.5455 25.723 19.459 24.8095 20.582 24.8095Z"
      fill="#2F54EB"
    />
  </svg>
);

export const FactoryIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_180488_3808)">
      <path d="M16.9375 26.25H19.75V32H16.9375V26.25Z" fill="#9254DE" />
      <path d="M21.625 26.25H24.4375V32H21.625V26.25Z" fill="#9254DE" />
      <path
        d="M31.9998 12.5454L24.4373 16.2954V12.5454L16.9373 16.2954V12.5454L9.99707 16.0156L11.3188 32H15.0623V24.375H26.3123V32H31.9998V12.5454ZM16.9373 22.5H13.1873V20.625H16.9373V22.5ZM22.5623 22.5H18.8123V20.625H22.5623V22.5ZM28.1873 22.5H24.4373V20.625H28.1873V22.5Z"
        fill="#9254DE"
      />
      <path
        d="M3.99902 5.06372L5.49854 6.18896C5.51685 6.16431 7.37646 3.76099 10.3784 3.75C13.8257 3.72485 14.677 7.50562 18.804 7.50562H18.8132V7.5C20.8809 7.49951 22.5623 5.81787 22.5623 3.75C22.5623 1.68188 20.8804 0 18.8123 0C17.9106 0 17.3845 0.301758 16.9253 0.441406C16.8938 0.844971 17.0222 1.37256 16.8008 1.58838C16.1616 2.21436 13.0845 1.80688 10.3784 1.87524C10.3757 1.87524 10.3738 1.875 10.3711 1.875C10.3701 1.875 10.3694 1.87524 10.3687 1.87524C10.3618 1.87549 10.356 1.87476 10.3491 1.875L10.3494 1.8772C6.40723 1.90381 4.09497 4.93506 3.99902 5.06372Z"
        fill="#9254DE"
      />
      <path
        d="M1.71875 11.25H7.71875L7.5625 9.375H9.4375V7.5H0V9.375H1.875L1.71875 11.25Z"
        fill="#9254DE"
      />
      <path d="M8.1875 16.875H1.25L0 32H9.4375L8.1875 16.875Z" fill="#9254DE" />
      <path
        d="M1.40625 15H8.03125L7.875 13.125H1.5625L1.40625 15Z"
        fill="#9254DE"
      />
    </g>
    <defs>
      <clipPath id="clip0_180488_3808">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FinExportIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.707 21.293L27.707 19.293C27.3164 18.9023 26.6836 18.9023 26.293 19.293C25.9023 19.6836 25.9023 20.3164 26.293 20.707L26.5859 21H20C19.4473 21 19 21.4473 19 22C19 22.5527 19.4473 23 20 23H26.5859L26.293 23.293C25.9023 23.6836 25.9023 24.3164 26.293 24.707C26.4883 24.9023 26.7441 25 27 25C27.2559 25 27.5117 24.9023 27.707 24.707L29.707 22.707C30.0977 22.3164 30.0977 21.6836 29.707 21.293Z"
      fill="#FA541C"
    />
    <path
      d="M17.9988 17.9924L10.5 21.3253V30.0002L17.3936 26.9191C17.7617 26.7619 18 26.4001 18 26.0002V18.0002C18 17.9975 17.9988 17.9951 17.9988 17.9924Z"
      fill="#FA541C"
    />
    <path
      d="M7 14.1134V11C7 10.4477 6.55231 10 6 10H4C3.44769 10 3 10.4477 3 11V15.836C3.6886 15.5388 4.89539 15.0191 7 14.1134Z"
      fill="#FA541C"
    />
    <path
      d="M9.21094 13.1621C9.45898 13.0547 9.72559 13 10 13C10.2744 13 10.541 13.0547 10.791 13.1631C11.2202 13.3477 11.621 13.5202 12 13.6832V7C12 6.44769 11.5523 6 11 6H9C8.44769 6 8 6.44769 8 7V13.6831C8.37952 13.5198 8.78101 13.347 9.21094 13.1621Z"
      fill="#FA541C"
    />
    <path
      d="M17 15.8361V3C17 2.44769 16.5523 2 16 2H14C13.4477 2 13 2.44769 13 3V14.1135C15.1046 15.0192 16.3113 15.5388 17 15.8361Z"
      fill="#FA541C"
    />
    <path
      d="M10.3933 14.0813C10.1433 13.9729 9.8562 13.9729 9.6062 14.0813C9.6062 14.0813 2.55341 17.1157 2.52539 17.131L9.99976 20.4529L17.4741 17.131C17.4461 17.1157 10.3933 14.0813 10.3933 14.0813Z"
      fill="#FA541C"
    />
    <path
      d="M2 18.0002V26.0002C2 26.4001 2.23828 26.7619 2.60645 26.9191L9.5 30.0002V21.3253L2.00116 17.9924C2.00116 17.9951 2 17.9975 2 18.0002Z"
      fill="#FA541C"
    />
    <path
      d="M22.5 2C20.8092 2 19.2544 2.56628 18 3.51025V15.4897C19.2544 16.4337 20.8092 17 22.5 17C26.6422 17 30 13.6422 30 9.5C30 5.35785 26.6422 2 22.5 2ZM22.5 9C23.8789 9 25 10.1216 25 11.5C25 12.7072 24.14 13.7171 23 13.9494V14.5C23 14.7764 22.7764 15 22.5 15C22.2236 15 22 14.7764 22 14.5V13.9494C20.86 13.7171 20 12.7072 20 11.5C20 11.2236 20.2236 11 20.5 11C20.7764 11 21 11.2236 21 11.5C21 12.3271 21.6729 13 22.5 13C23.3271 13 24 12.3271 24 11.5C24 10.6729 23.3271 10 22.5 10C21.1211 10 20 8.87842 20 7.5C20 6.29279 20.86 5.2829 22 5.0506V4.5C22 4.22363 22.2236 4 22.5 4C22.7764 4 23 4.22363 23 4.5V5.0506C24.14 5.2829 25 6.29279 25 7.5C25 7.77637 24.7764 8 24.5 8C24.2236 8 24 7.77637 24 7.5C24 6.67285 23.3271 6 22.5 6C21.6729 6 21 6.67285 21 7.5C21 8.32715 21.6729 9 22.5 9Z"
      fill="#FA541C"
    />
  </svg>
);

export const FactoryOrangeIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_180488_3835)">
      <path d="M16.9375 26.25H19.75V32H16.9375V26.25Z" fill="#FA8C16" />
      <path d="M21.625 26.25H24.4375V32H21.625V26.25Z" fill="#FA8C16" />
      <path
        d="M31.9998 12.5454L24.4373 16.2954V12.5454L16.9373 16.2954V12.5454L9.99707 16.0156L11.3188 32H15.0623V24.375H26.3123V32H31.9998V12.5454ZM16.9373 22.5H13.1873V20.625H16.9373V22.5ZM22.5623 22.5H18.8123V20.625H22.5623V22.5ZM28.1873 22.5H24.4373V20.625H28.1873V22.5Z"
        fill="#FA8C16"
      />
      <path
        d="M3.99902 5.06372L5.49854 6.18896C5.51685 6.16431 7.37646 3.76099 10.3784 3.75C13.8257 3.72485 14.677 7.50562 18.804 7.50562H18.8132V7.5C20.8809 7.49951 22.5623 5.81787 22.5623 3.75C22.5623 1.68188 20.8804 0 18.8123 0C17.9106 0 17.3845 0.301758 16.9253 0.441406C16.8938 0.844971 17.0222 1.37256 16.8008 1.58838C16.1616 2.21436 13.0845 1.80688 10.3784 1.87524C10.3757 1.87524 10.3738 1.875 10.3711 1.875C10.3701 1.875 10.3694 1.87524 10.3687 1.87524C10.3618 1.87549 10.356 1.87476 10.3491 1.875L10.3494 1.8772C6.40723 1.90381 4.09497 4.93506 3.99902 5.06372Z"
        fill="#FA8C16"
      />
      <path
        d="M1.71875 11.25H7.71875L7.5625 9.375H9.4375V7.5H0V9.375H1.875L1.71875 11.25Z"
        fill="#FA8C16"
      />
      <path d="M8.1875 16.875H1.25L0 32H9.4375L8.1875 16.875Z" fill="#FA8C16" />
      <path
        d="M1.40625 15H8.03125L7.875 13.125H1.5625L1.40625 15Z"
        fill="#FA8C16"
      />
    </g>
    <defs>
      <clipPath id="clip0_180488_3835">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PollIcon = (
  <svg
    width="129"
    height="128"
    viewBox="0 0 129 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M96.6426 57.5467V78.88C96.6426 80.2667 96.5888 81.6 96.4275 82.88C95.1913 97.28 86.645 104.427 70.8963 104.427H68.7463C67.4025 104.427 66.1125 105.067 65.3062 106.133L58.8563 114.667C56.0076 118.453 51.385 118.453 48.5362 114.667L42.0862 106.133C41.3874 105.227 39.8288 104.427 38.6463 104.427H36.4963C19.35 104.427 10.75 100.213 10.75 78.88V57.5467C10.75 41.92 18.0063 33.44 32.465 32.2134C33.755 32.0534 35.0988 32 36.4963 32H70.8963C88.0425 32 96.6426 40.5334 96.6426 57.5467Z"
      fill="#F0F5FF"
    />
    <path
      d="M53.6953 74.6667C50.6853 74.6667 48.3203 72.2667 48.3203 69.3333C48.3203 66.4 50.7391 64 53.6953 64C56.6516 64 59.0703 66.4 59.0703 69.3333C59.0703 72.2667 56.7053 74.6667 53.6953 74.6667Z"
      fill="#F0F5FF"
    />
    <path
      d="M72.5078 74.6667C69.4978 74.6667 67.1328 72.2667 67.1328 69.3333C67.1328 66.4 69.5516 64 72.5078 64C75.4641 64 77.8828 66.4 77.8828 69.3333C77.8828 72.2667 75.4641 74.6667 72.5078 74.6667Z"
      fill="#F0F5FF"
    />
    <path
      d="M34.9375 74.6667C31.9275 74.6667 29.5625 72.2667 29.5625 69.3333C29.5625 66.4 31.9813 64 34.9375 64C37.8938 64 40.3125 66.4 40.3125 69.3333C40.3125 72.2667 37.8938 74.6667 34.9375 74.6667Z"
      fill="#F0F5FF"
    />
    <path
      d="M118.142 36.2133V57.5467C118.142 73.2267 110.886 81.6533 96.4273 82.88C96.5886 81.6 96.6424 80.2667 96.6424 78.88V57.5467C96.6424 40.5333 88.0423 32 70.8961 32H36.4961C35.0986 32 33.7548 32.0533 32.4648 32.2133C33.7011 17.8667 42.2473 10.6666 57.9961 10.6666H92.3961C109.542 10.6666 118.142 19.2 118.142 36.2133Z"
      fill="#F0F5FF"
    />
  </svg>
);

export const PollTargetIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0007 3.33337C21.494 3.33337 22.9407 3.53004 24.3173 3.89837L20.774 7.44004C20.5052 7.70993 20.2681 8.00965 20.0673 8.33337H20.0007C17.6932 8.33337 15.4376 9.01761 13.519 10.2996C11.6004 11.5815 10.1051 13.4036 9.22206 15.5354C8.33903 17.6672 8.108 20.013 8.55816 22.2761C9.00832 24.5392 10.1195 26.618 11.7511 28.2496C13.3827 29.8812 15.4615 30.9924 17.7246 31.4425C19.9877 31.8927 22.3335 31.6617 24.4653 30.7786C26.5971 29.8956 28.4192 28.4003 29.7011 26.4817C30.9831 24.5631 31.6673 22.3075 31.6673 20V19.9334C31.9895 19.7334 32.2868 19.4973 32.559 19.225L36.1023 15.6834C36.4706 17.06 36.6673 18.5067 36.6673 20C36.6673 29.205 29.2057 36.6667 20.0007 36.6667C10.7957 36.6667 3.33398 29.205 3.33398 20C3.33398 10.795 10.7957 3.33337 20.0007 3.33337ZM19.3107 11.695C19.3107 13.1134 19.2407 14.5517 19.3173 15.9684L18.4173 16.8684C18.1077 17.178 17.8621 17.5455 17.6946 17.95C17.527 18.3545 17.4408 18.788 17.4408 19.2259C17.4408 19.6637 17.527 20.0972 17.6946 20.5017C17.8621 20.9062 18.1077 21.2738 18.4173 21.5834C18.7269 21.893 19.0944 22.1385 19.4989 22.3061C19.9034 22.4736 20.337 22.5599 20.7748 22.5599C21.2126 22.5599 21.6462 22.4736 22.0507 22.3061C22.4552 22.1385 22.8227 21.893 23.1323 21.5834L24.0323 20.6834C25.449 20.76 26.8857 20.69 28.3057 20.69C28.174 22.2739 27.5921 23.7872 26.6287 25.0512C25.6653 26.3153 24.3604 27.2775 22.8681 27.8243C21.3758 28.3711 19.7582 28.4798 18.2061 28.1375C16.6541 27.7952 15.2323 27.0161 14.1084 25.8923C12.9846 24.7684 12.2055 23.3466 11.8632 21.7946C11.5209 20.2425 11.6296 18.6249 12.1764 17.1326C12.7232 15.6403 13.6854 14.3354 14.9495 13.372C16.2135 12.4086 17.7268 11.8267 19.3107 11.695ZM30.8407 3.54504C31.1449 3.67117 31.4049 3.8846 31.5879 4.15839C31.7709 4.43218 31.8687 4.75405 31.869 5.08337V8.13337H34.9173C35.2469 8.13344 35.5691 8.23123 35.8431 8.41437C36.1171 8.59751 36.3307 8.85778 36.4568 9.16228C36.5829 9.46678 36.6159 9.80184 36.5516 10.1251C36.4873 10.4483 36.3287 10.7453 36.0956 10.9784L30.2007 16.8667C29.8882 17.1793 29.4643 17.3549 29.0223 17.355H25.0007L21.954 20.4034C21.6412 20.7161 21.2171 20.8918 20.7748 20.8918C20.3325 20.8918 19.9084 20.7161 19.5956 20.4034C19.2829 20.0906 19.1072 19.6665 19.1072 19.2242C19.1072 18.7819 19.2829 18.3578 19.5956 18.045L22.644 15V10.9767C22.6438 10.7576 22.6869 10.5406 22.7706 10.3381C22.8544 10.1356 22.9773 9.95163 23.1323 9.79671L29.024 3.90504C29.2571 3.67182 29.5541 3.51297 29.8774 3.44859C30.2008 3.38421 30.536 3.4172 30.8407 3.54337"
      fill="#2F54EB"
    />
  </svg>
);

export const PollResultIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.5 7.5H33.75V36.25H6.25V7.5H12.5V10H27.5V7.5ZM11.25 20H28.75V17.5H11.25V20ZM11.25 30H28.75V27.5H11.25V30ZM15 7.5V3.75H25V7.5H15Z"
      fill="#2F54EB"
    />
  </svg>
);

export const PollExclamationIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2768 9.93333C14.1576 9.11224 14.2165 8.27511 14.4494 7.47878C14.6823 6.68245 15.0839 5.94556 15.6268 5.31814C16.1697 4.69073 16.8412 4.18747 17.5958 3.84254C18.3504 3.49762 19.1704 3.31909 20.0001 3.31909C20.8298 3.31909 21.6498 3.49762 22.4044 3.84254C23.159 4.18747 23.8306 4.69073 24.3735 5.31814C24.9164 5.94556 25.3179 6.68245 25.5509 7.47878C25.7838 8.27511 25.8427 9.11224 25.7235 9.93333L23.8035 23.3667C23.6706 24.2805 23.2131 25.116 22.5147 25.7202C21.8162 26.3244 20.9236 26.6569 20.0001 26.6569C19.0766 26.6569 18.184 26.3244 17.4856 25.7202C16.7872 25.116 16.3297 24.2805 16.1968 23.3667L14.2768 9.93333ZM23.3335 33.3333C23.3335 34.2174 22.9823 35.0652 22.3572 35.6903C21.732 36.3155 20.8842 36.6667 20.0001 36.6667C19.1161 36.6667 18.2682 36.3155 17.6431 35.6903C17.018 35.0652 16.6668 34.2174 16.6668 33.3333C16.6668 32.4493 17.018 31.6014 17.6431 30.9763C18.2682 30.3512 19.1161 30 20.0001 30C20.8842 30 21.732 30.3512 22.3572 30.9763C22.9823 31.6014 23.3335 32.4493 23.3335 33.3333Z"
      fill="#2F54EB"
    />
  </svg>
);
